/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
//import logoCopyAdmin from '../../../img/logos-admin.svg';
//import lightLogo from '../../../img/logo-light.svg';
import { Link, useHistory } from "react-router-dom";
//import $ from 'jquery';
import {
  MERCHANT_BACKGROUND_COLOR,
  //MERCHANT_LOGO_WHITE,
} from "../../../../utils/env";
import { ReactComponent as MenuDashboard } from "../../../../img/fi-rr-apps.svg";

import DashWhite from "../../../../img/dashboard_white.svg";
import DashBlue from "../../../../img/dashboard_blue.svg";
import LinkWhite from "../../../../img/link_white.svg";
import LinkBlue from "../../../../img/link_blue.svg";

//import DataSaveWhite from '../../../../img/data_saver_white.svg';
//import DataSaveBlue from '../../../../img/data_saver_blue.svg';

//import ThumbUpBlue from '../../../../img/thumb_up_blue.svg';
//import ThumbUpWhite from '../../../../img/thumb_up_white.svg';

import FmdBlue from "../../../../img/fmd_blue.svg";
import FmdWhite from "../../../../img/fmd_white.svg";

import StoreBlue from "../../../../img/store_blue.svg";
import StoreWhite from "../../../../img/store_white.svg";

import AccountBlue from "../../../../img/account_blue.svg";
import AccountWhite from "../../../../img/account_white.svg";

import InfoBlue from "../../../../img/info_blue.svg";
import InfoWhite from "../../../../img/info_white.svg";

import BlockBlue from "../../../../img/block_blue.svg";
import BlockWhite from "../../../../img/block_white.svg";

import AccountCircleBlue from "../../../../img/account_circle_blue.svg";
import AccountCircleWhite from "../../../../img/account_circle_white.svg";

import PaymentDefault from "../../../../img/payments-default.svg";
import PaymentWhite from "../../../../img/payments-white.svg";

import ExpandMoreDefault from "../../../../img/expand_more-default.svg";
import ExpandMoreWhite from "../../../../img/expand_more-white.svg";

import ThumbsUpDownDefault from "../../../../img/thumbs_up_down-default.svg";
import ThumbsUpDownGray from "../../../../img/thumbs_up_down-gray.svg";

import BarChartDefault from "../../../../img/bar_chart-default.svg";
import BarChartGray from "../../../../img/bar_chart-gray.svg";

import PendingActionsDefault from "../../../../img/pending_actions-default.svg";
import PendingActionsGray from "../../../../img/pending_actions-gray.svg";

import { ReactComponent as MenuConta } from "../../../../img/fi-rr-calculator.svg";
import { ReactComponent as MenuInfo } from "../../../../img/fi-rr-info.svg";
import { ReactComponent as MenuUnidades } from "../../../../img/fi-rr-marker.svg";
import { ReactComponent as MenuVenda } from "../../../../img/fi-rr-shop.svg";
import { ReactComponent as MenuRelatorio } from "../../../../img/fi-rr-stats.svg";
import { ReactComponent as MenuConciliacao } from "../../../../img/fi-rr-thumbs-up.svg";
import { ReactComponent as MenuUser } from "../../../../img/fi-rr-users.svg";
import { ReactComponent as RestricaoIcon } from "../../../../img/ban.svg";
import OrangePigzPay from "../../../../img/orange-pigzpay-logo.svg";
import OrangeLabs from "../../../../img/orange-labs-logo.svg";

import * as S from "./style";

//import {UilReact} from '@iconscout/react-unicons/icons';
//https://iconscout.com/unicons/explore/line
//import { UilReact } from '@iconscout/react-unicons'

function Menu(props: any) {
  //console.log(props,'props')

  const [path, setPath] = useState(
    window.location.pathname
    //sessionStorage.getItem('@amEnergiaPigz-path')
  );
  const [permissao, setPermissao] = useState(props.permissao);
  const [loading, setLoading] = useState(props.loading);

  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    setLoading(props.loading);
    setPermissao(props.permissao);
  }, [props]);

  useEffect(() => {
    console.log(window.location.pathname, "path");
  }, [window.location.pathname]);

  function activeMenu(path: any) {
    //console.log(sessionStorage.getItem('@amEnergiaPigz-path'));
    setPath(path);
    sessionStorage.setItem("@amEnergiaPigz-path", path);
    //console.log(window.location.pathName,'path')

    //console.log(permissao);
  }

  //const ROLE = localStorage.getItem('ROLE');
  //const { path,permissao } = this.state;
  /*<S.Menu open={true}>
            <S.MenuImg open={true}>
                <Link onClick={() => activeMenu('/admin')} to='/admin'>
                    <S.MenuHeader
                        open={true}
                        onClick={(e) => {
                            e.preventDefault();
                            //setOpen(!open);
                        }}>
                        <S.MenuImg
                            open={true}
                            src={`${process.env.PUBLIC_URL}/images/${process.env.REACT_APP_FOLDER_IMAGE}/logo-branca.svg`}
                            alt='Merchant_logo'
                        />
                    </S.MenuHeader>
                </Link>
            </S.MenuImg>
        </S.Menu>*/

  //return (
  const history = useHistory();

  const dashItem = {
    path: "/admin/dash",
    label: "Dashboard",
    iconOn: <img alt="Dashboard" src={DashBlue} />,
    iconOff: <img alt="Dashboard" src={DashWhite} />,
    icon: (
      <MenuDashboard
        className={
          path === "/admin/dash" ? "menu-img menu-img-selected" : "menu-img"
        }
      />
    ),
  };

  const linkItem = {
    path: "/admin/link",
    label: "Link de pagamento",
    iconOn: <img alt="link" src={LinkBlue} />,
    iconOff: <img alt="link" src={LinkWhite} />,
    icon: (
      <MenuDashboard
        className={
          path === "/admin/link" ? "menu-img menu-img-selected" : "menu-img"
        }
      />
    ),
  };

  function checkIfChildOpen() {
    const f = pagamentosItems.find((pi) => pi.path === path);

    if (f) return true;
    return false;
  }

  const pagamentosItems = [
    {
      path: "/admin",
      label: "Relatórios",
      iconOn: <img alt="R" src={BarChartDefault} />,
      iconOff: <img alt="R" src={BarChartGray} />,
      icon: (
        <MenuDashboard
          className={
            path === "/admin/dash" ? "menu-img menu-img-selected" : "menu-img"
          }
        />
      ),
    },
    {
      path: "/admin/pendencias",
      label: "Pendências",
      iconOn: <img alt="P" src={PendingActionsDefault} />,
      iconOff: <img alt="P" src={PendingActionsGray} />,
      icon: (
        <MenuDashboard
          className={
            path === "/admin/dash" ? "menu-img menu-img-selected" : "menu-img"
          }
        />
      ),
    },
    {
      path: "/admin/conciliacao",
      label: "Conciliações",
      iconOn: <img alt="C" src={ThumbsUpDownDefault} />,
      iconOff: <img alt="C" src={ThumbsUpDownGray} />,
      icon: (
        <MenuDashboard
          className={
            path === "/admin/dash" ? "menu-img menu-img-selected" : "menu-img"
          }
        />
      ),
    },
  ];

  const listMenu =
    permissao === -1
      ? []
      : permissao === 2
      ? [
          {
            path: "/admin/unidade",
            label: "Unidades",
            iconOn: <img alt="C" src={FmdBlue} />,
            iconOff: <img alt="C" src={FmdWhite} />,
            icon: (
              <MenuUnidades
                className={
                  path === "/admin/unidade"
                    ? "menu-img menu-img-selected"
                    : "menu-img"
                }
              />
            ),
          },
          {
            path: "/admin/pontovenda",
            label: "Pontos de Venda",
            iconOn: <img alt="C" src={StoreBlue} />,
            iconOff: <img alt="C" src={StoreWhite} />,
            icon: (
              <MenuVenda
                className={
                  path === "/admin/pontovenda"
                    ? "menu-img menu-img-selected"
                    : "menu-img"
                }
              />
            ),
          },
          {
            path: "/admin/conta",
            label: "Contas",
            iconOn: <img alt="C" src={AccountBlue} />,
            iconOff: <img alt="C" src={AccountWhite} />,
            icon: (
              <MenuConta
                className={
                  path === "/admin/conta"
                    ? "menu-img menu-img-selected"
                    : "menu-img"
                }
              />
            ),
          },
          {
            path: "/admin/informativo",
            label: "Informativos",
            iconOn: <img alt="C" src={InfoBlue} />,
            iconOff: <img alt="C" src={InfoWhite} />,
            icon: (
              <MenuInfo
                className={
                  path === "/admin/informativo"
                    ? "menu-img menu-img-selected"
                    : "menu-img"
                }
              />
            ),
          },

          {
            path: "/admin/restricao",
            label: "Restrições",
            iconOn: <img alt="C" src={BlockBlue} />,
            iconOff: <img alt="C" src={BlockWhite} />,
            icon: (
              <RestricaoIcon
                className={
                  path === "/admin/restricao"
                    ? "menu-img menu-img-selected"
                    : "menu-img"
                }
              />
            ),
          },

          {
            path: "/admin/usuario",
            label: "Usuários",
            iconOn: <img alt="C" src={AccountCircleBlue} />,
            iconOff: <img alt="C" src={AccountCircleWhite} />,
            icon: (
              <MenuUser
                className={
                  path === "/admin/usuario"
                    ? "menu-img menu-img-selected"
                    : "menu-img"
                }
              />
            ),
          },
        ]
      : [
          {
            path: "/admin/unidade",
            label: "Unidades",
            iconOn: <img alt="C" src={FmdBlue} />,
            iconOff: <img alt="C" src={FmdWhite} />,
            icon: (
              <MenuUnidades
                className={
                  path === "/admin/unidade"
                    ? "menu-img menu-img-selected"
                    : "menu-img"
                }
              />
            ),
          },
          {
            path: "/admin/pontovenda",
            label: "Pontos de Venda",
            iconOn: <img alt="C" src={StoreBlue} />,
            iconOff: <img alt="C" src={StoreWhite} />,
            icon: (
              <MenuVenda
                className={
                  path === "/admin/pontovenda"
                    ? "menu-img menu-img-selected"
                    : "menu-img"
                }
              />
            ),
          },
        ];

  return (
    <div className="abc">
      <S.Menu open>
        <S.MenuItems open>
          {permissao !== -1 ? (
            <Link onClick={() => activeMenu("/admin")} to="/admin">
              <S.MenuHeader
                open={true}
                onClick={(e) => {
                  e.preventDefault();
                  //setOpen(!open);
                  activeMenu("/admin");
                  history.push("/admin");
                }}
              >
                <S.MenuImg
                  open={true}
                  src={`${process.env.PUBLIC_URL}/images/${process.env.REACT_APP_FOLDER_IMAGE}/logo-branca.svg`}
                  alt="Merchant_logo"
                />
              </S.MenuHeader>
            </Link>
          ) : (
            <S.MenuHeader
              open={true}
              onClick={(e) => {
                e.preventDefault();
                //setOpen(!open);
                // activeMenu("/admin");
                //history.push("/admin");
              }}
            >
              <S.MenuImg
                open={true}
                src={`${process.env.PUBLIC_URL}/images/${process.env.REACT_APP_FOLDER_IMAGE}/logo-branca.svg`}
                alt="Merchant_logo"
              />
            </S.MenuHeader>
          )}
          {permissao !== -1 && (
            <Link
              className="link_menu"
              onClick={() => activeMenu(dashItem.path)}
              to={dashItem.path}
            >
              <S.MenuItem active={path === dashItem.path} open>
                {path === dashItem.path ? dashItem.iconOn : dashItem.iconOff}
                <span
                  className={
                    path === "/admin/dash"
                      ? "menu-text-item-selected"
                      : "menu-text-item"
                  }
                >
                  <S.MenuText>{dashItem.label}</S.MenuText>
                </span>

                {path === dashItem.path && <span className="menuGreenDot" />}
              </S.MenuItem>
            </Link>
          )}
          <Link
            className="link_menu"
            onClick={() => activeMenu(linkItem.path)}
            to={linkItem.path}
          >
            <S.MenuItem active={path === linkItem.path} open>
              {path === linkItem.path ? linkItem.iconOn : linkItem.iconOff}
              <span
                className={
                  path === "/admin/link"
                    ? "menu-text-item-selected"
                    : "menu-text-item"
                }
              >
                <S.MenuText>{"Link de pagamento"}</S.MenuText>
              </span>

              {path === linkItem.path && <span className="menuGreenDot" />}
            </S.MenuItem>
          </Link>
          {permissao !== -1 && (
            <div>
              <S.MenuItemPagamento
                style={{ transition: "all 0.4s" }}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenMenu(!openMenu);
                }}
                opened={openMenu}
                active={openMenu || checkIfChildOpen()}
                open
              >
                <div className="header_container_pay">
                  {openMenu || checkIfChildOpen() ? (
                    <img alt="C" src={PaymentDefault} />
                  ) : (
                    <img alt="C" src={PaymentWhite} />
                  )}
                  <div
                    className={
                      openMenu ? "menu-text-item-selected" : "menu-text-item"
                    }
                  >
                    <S.MenuText>{"Pagamentos"}</S.MenuText>
                  </div>
                  <div className="open_close_item">
                    <img
                      className="open_close_item_icon_on"
                      alt="C"
                      src={ExpandMoreDefault}
                    />
                    <img
                      className="open_close_item_icon_off"
                      alt="C"
                      src={ExpandMoreWhite}
                    />
                  </div>
                  {checkIfChildOpen() && !openMenu && (
                    <span className="menuGreenDot" />
                  )}
                </div>

                {pagamentosItems.map((pi) => (
                  <S.MenuSubItem
                    onClick={(e) => {
                      e.stopPropagation();
                      history.replace(pi.path);
                      activeMenu(pi.path);
                    }}
                    opened={openMenu}
                    active={path === pi.path}
                    open
                  >
                    {path === pi.path ? pi.iconOn : pi.iconOff}

                    <span
                      className={
                        path === "/admin/dash"
                          ? "menu-text-item-selected"
                          : "menu-text-item"
                      }
                    >
                      <S.MenuText>{pi.label}</S.MenuText>
                    </span>
                    {path === pi.path && <span className="menuGreenDot" />}
                  </S.MenuSubItem>
                ))}
              </S.MenuItemPagamento>
            </div>
          )}
          {listMenu.map((lm) => (
            <Link onClick={() => activeMenu(lm.path)} to={lm.path}>
              <S.MenuItem active={path === lm.path} open>
                {path === lm.path ? lm.iconOn : lm.iconOff}
                <span
                  className={
                    path === "/admin/dash"
                      ? "menu-text-item-selected"
                      : "menu-text-item"
                  }
                >
                  <S.MenuText>{lm.label}</S.MenuText>
                </span>
                {path === lm.path && <span className="menuGreenDot" />}
              </S.MenuItem>
            </Link>
          ))}
        </S.MenuItems>
        <S.Footer open>
          <div className="menu_footer_item">
            <img
              alt="Orange"
              src={`${process.env.PUBLIC_URL}/images/logo-orange-branco.svg`}
            />
          </div>
        </S.Footer>
      </S.Menu>
    </div>
  );

  // eslint-disable-next-line no-unreachable
  return (
    <div
      className="Menu menu-overflow "
      style={{ backgroundColor: `${MERCHANT_BACKGROUND_COLOR}` }}
    >
      <div style={{ display: "flex" }} className="pl-3 logoBoxAdmin">
        <Link
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => activeMenu("/admin")}
          to="/admin"
        >
          <img
            style={{ height: 64 }}
            src={`${process.env.PUBLIC_URL}/images/${process.env.REACT_APP_FOLDER_IMAGE}/logo-branca.svg`}
            //src={`/build/images/${MERCHANT_LOGO_WHITE}`}
            // width='60%'
            alt="MERCHANTLOGO"
          />
        </Link>
      </div>
      <div className="">
        <nav>
          {loading ? (
            <ul className="nav flex-column mb-5">
              <li className={"nav-item mt-3"}>
                <div className="menu-item pl-3">
                  <div
                    className="Skeleton-menu"
                    style={{ width: 16, height: 16, marginRight: 10 }}
                  ></div>

                  <span
                    style={{ width: 150, height: 20 }}
                    className={"menu-text-item Skeleton-menu"}
                  ></span>
                </div>
              </li>
              <li className={"nav-item mt-3"}>
                <div className="menu-item pl-3">
                  <div
                    className="Skeleton-menu"
                    style={{ width: 16, height: 16, marginRight: 10 }}
                  ></div>

                  <span
                    style={{ width: 150, height: 20 }}
                    className={"menu-text-item Skeleton-menu"}
                  ></span>
                </div>
              </li>
              <li className={"nav-item mt-3"}>
                <div className="menu-item pl-3">
                  <div
                    className="Skeleton-menu"
                    style={{ width: 16, height: 16, marginRight: 10 }}
                  ></div>

                  <span
                    style={{ width: 150, height: 20 }}
                    className={"menu-text-item Skeleton-menu"}
                  ></span>
                </div>
              </li>
              <li className={"nav-item mt-3"}>
                <div className="menu-item pl-3">
                  <div
                    className="Skeleton-menu"
                    style={{ width: 16, height: 16, marginRight: 10 }}
                  ></div>

                  <span
                    style={{ width: 150, height: 20 }}
                    className={"menu-text-item Skeleton-menu"}
                  ></span>
                </div>
              </li>
              <li className={"nav-item mt-3"}>
                <div className="menu-item pl-3">
                  <div
                    className="Skeleton-menu"
                    style={{ width: 16, height: 16, marginRight: 10 }}
                  ></div>

                  <span
                    style={{ width: 150, height: 20 }}
                    className={"menu-text-item Skeleton-menu"}
                  ></span>
                </div>
              </li>
            </ul>
          ) : (
            <ul className="nav flex-column mb-5">
              <li
                className={
                  "nav-item mt-3" +
                  (path === "/admin/dash" ? " nav-active" : "")
                }
              >
                <Link
                  className="menu-item pl-3"
                  onClick={() => activeMenu("/admin/dash")}
                  to="/admin/dash"
                >
                  <MenuDashboard
                    className={
                      path === "/admin/dash"
                        ? "menu-img menu-img-selected"
                        : "menu-img"
                    }
                  />
                  <span
                    className={
                      path === "/admin/dash"
                        ? "menu-text-item-selected"
                        : "menu-text-item"
                    }
                  >
                    Dashboard
                  </span>
                </Link>
              </li>
              <li
                className={
                  "nav-item mt-3" + (path === "/admin" ? " nav-active" : "")
                }
              >
                <Link
                  className="menu-item pl-3"
                  onClick={() => activeMenu("/admin")}
                  to="/admin"
                >
                  <MenuRelatorio
                    className={
                      path === "/admin"
                        ? "menu-img menu-img-selected"
                        : "menu-img"
                    }
                  />

                  <span
                    className={
                      path === "/admin"
                        ? "menu-text-item-selected"
                        : "menu-text-item"
                    }
                  >
                    Relatório de pagamentos
                  </span>
                </Link>
              </li>
              {/* <li
               			 className={
              		    "nav-item mt-3 pl-3" + (path == "/admin" ? " nav-active" : "")
             		   }
           				   >
           				     <Link onClick={() => activeMenu("/admin")} to="/admin">
           				       <span>Relatório de Transações</span>
          					      </Link>
         				     </li> */}
              <li
                className={
                  "nav-item mt-3" +
                  (path === "/admin/conciliacao" ? " nav-active" : "")
                }
              >
                <Link
                  className="menu-item pl-3"
                  onClick={() => activeMenu("/admin/conciliacao")}
                  to="/admin/conciliacao"
                >
                  <MenuConciliacao
                    className={
                      path === "/admin/conciliacao"
                        ? "menu-img menu-img-selected"
                        : "menu-img"
                    }
                  />
                  <span
                    className={
                      path === "/admin/conciliacao"
                        ? "menu-text-item-selected"
                        : "menu-text-item"
                    }
                  >
                    Conciliações
                  </span>
                </Link>
              </li>
              <li
                className={
                  "nav-item mt-3" +
                  (path === "/admin/unidade" ? " nav-active" : "")
                }
              >
                <Link
                  className="menu-item pl-3"
                  onClick={() => activeMenu("/admin/unidade")}
                  to="/admin/unidade"
                >
                  <MenuUnidades
                    className={
                      path === "/admin/unidade"
                        ? "menu-img menu-img-selected"
                        : "menu-img"
                    }
                  />
                  <span
                    className={
                      path === "/admin/unidade"
                        ? "menu-text-item-selected"
                        : "menu-text-item"
                    }
                  >
                    Unidades
                  </span>
                </Link>
              </li>
              <li
                className={
                  "nav-item mt-3" +
                  (path === "/admin/pontovenda" ? " nav-active" : "")
                }
              >
                <Link
                  className="menu-item pl-3"
                  onClick={() => activeMenu("/admin/pontovenda")}
                  to="/admin/pontovenda"
                >
                  <MenuVenda
                    className={
                      path === "/admin/pontovenda"
                        ? "menu-img menu-img-selected"
                        : "menu-img"
                    }
                  />
                  <span
                    className={
                      path === "/admin/pontovenda"
                        ? "menu-text-item-selected"
                        : "menu-text-item"
                    }
                  >
                    Pontos de Venda
                  </span>
                </Link>
              </li>
              {
                <>
                  {permissao === 2 && (
                    <li
                      className={
                        "nav-item mt-3" +
                        (path === "/admin/conta" ? " nav-active" : "")
                      }
                    >
                      <Link
                        className="menu-item pl-3"
                        onClick={() => activeMenu("/admin/conta")}
                        to="/admin/conta"
                      >
                        <MenuConta
                          className={
                            path === "/admin/conta"
                              ? "menu-img menu-img-selected"
                              : "menu-img"
                          }
                        />
                        <span
                          className={
                            path === "/admin/conta"
                              ? "menu-text-item-selected"
                              : "menu-text-item"
                          }
                        >
                          Contas
                        </span>
                      </Link>
                    </li>
                  )}
                  {/* <li
                                     className={"nav-item mt-3 pl-3" + (path == '/admin/notificacao' ? ' nav-active' : '')}
                                    >
                                        <Link onClick={() => activeMenu('/admin/notificacao')} to="/admin/notificacao">
                                            <span>
                                                Notificações
                                            </span>
                                        </Link>
                                    </li> */}
                  {permissao === 2 && (
                    <li
                      className={
                        "nav-item mt-3" +
                        (path === "/admin/informativo" ? " nav-active" : "")
                      }
                    >
                      <Link
                        className="menu-item pl-3"
                        onClick={() => activeMenu("/admin/informativo")}
                        to="/admin/informativo"
                      >
                        <MenuInfo
                          className={
                            path === "/admin/informativo"
                              ? "menu-img menu-img-selected"
                              : "menu-img"
                          }
                        />
                        <span
                          className={
                            path === "/admin/informativo"
                              ? "menu-text-item-selected"
                              : "menu-text-item"
                          }
                        >
                          Informativos
                        </span>
                      </Link>
                    </li>
                  )}

                  {permissao === 2 && (
                    <li
                      className={
                        "nav-item mt-3" +
                        (path === "/admin/restricao" ? " nav-active" : "")
                      }
                    >
                      <Link
                        className="menu-item pl-3"
                        onClick={() => activeMenu("/admin/restricao")}
                        to="/admin/restricao"
                      >
                        <RestricaoIcon
                          className={
                            path === "/admin/restricao"
                              ? "menu-img menu-img-selected"
                              : "menu-img"
                          }
                        />
                        <span
                          className={
                            path === "/admin/restricao"
                              ? "menu-text-item-selected"
                              : "menu-text-item"
                          }
                        >
                          Restrições
                        </span>
                      </Link>
                    </li>
                  )}
                  {permissao === 2 && (
                    <li
                      className={
                        "nav-item mt-3" +
                        (path === "/admin/usuario" ? " nav-active" : "")
                      }
                    >
                      <Link
                        className="menu-item pl-3"
                        onClick={() => activeMenu("/admin/usuario")}
                        to="/admin/usuario"
                      >
                        <MenuUser
                          className={
                            path === "/admin/usuario"
                              ? "menu-img menu-img-selected"
                              : "menu-img"
                          }
                        />
                        <span
                          className={
                            path === "/admin/usuario"
                              ? "menu-text-item-selected"
                              : "menu-text-item"
                          }
                        >
                          Usuários
                        </span>
                      </Link>
                    </li>
                  )}
                </>
              }
            </ul>
          )}
        </nav>
        <span
          style={{
            backgroundColor: "#FF671F",
            // display: "inline-block",
            paddingTop: 12.5,
            paddingBottom: 5,

            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,

            position: "fixed",
            bottom: 0,
            left: 24,
            width: 174,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <img style={{ width: 54, height: 15 }} src={OrangePigzPay} alt="" />
          <img style={{ width: 54, height: 15 }} src={OrangeLabs} alt="" />
        </span>
      </div>
    </div>
  );
}

export default Menu;

/**
 * <Link onClick={() => activeMenu('/admin/dash')} to='/admin/dash'>
						<S.MenuItem active={path === '/admin/dash'} open>
							<MenuDashboard
								className={
									path === '/admin/dash'
										? 'menu-img menu-img-selected'
										: 'menu-img'
								}
							/>
							<span
								className={
									path === '/admin/dash'
										? 'menu-text-item-selected'
										: 'menu-text-item'
								}>
								<S.MenuText>{'Dashboard'}</S.MenuText>
							</span>
						</S.MenuItem>
					</Link>

					<Link onClick={() => activeMenu('/admin')} to='/admin'>
						<S.MenuItem active={path === '/admin'} open>
							<MenuRelatorio
								className={
									path === '/admin' ? 'menu-img menu-img-selected' : 'menu-img'
								}
							/>
							<span
								className={
									path === '/admin'
										? 'menu-text-item-selected'
										: 'menu-text-item'
								}>
								<S.MenuText>{'Transações'}</S.MenuText>
							</span>
						</S.MenuItem>
					</Link>
				
 * 
 */
